// extracted by mini-css-extract-plugin
export default {"group":"Segmented_group__z8R+O","tab":"Segmented_tab__WaVGf","active":"Segmented_active__CakF2","count":"Segmented_count__aWHm2","sm":"Segmented_sm__APHC7"};